// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".user-profile-dadata-input .vs__input{border:1px solid #949aba!important;border-radius:0!important;font-family:\"Raleway\",sans-serif;font-size:1rem!important;font-weight:500;height:calc(1.5em + .75rem + 2px);line-height:1.5rem!important;padding:1.3rem 1rem!important}.user-profile-dadata-input .vs__input::-moz-placeholder{color:#959bba;font-weight:300}.user-profile-dadata-input .vs__input::placeholder{color:#959bba;font-weight:300}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
